export default __webpack_public_path__ + "static/Validation-Sprints-0c0d63e577efdbcc56f2c83c1e20d1e7.webp";